import { render, staticRenderFns } from "./BAlert.vue?vue&type=template&id=771d99a2&scoped=true"
import script from "./BAlert.vue?vue&type=script&lang=js"
export * from "./BAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d99a2",
  null
  
)

export default component.exports